import {useMemo} from 'react'

import {useAlf} from '#/alf'
import {admonition} from './semantic/colors/admonition'
import {bg} from './semantic/colors/bg'
import {border} from './semantic/colors/border'
import {button} from './semantic/colors/button'
import {dialog} from './semantic/colors/dialog'
import {input} from './semantic/colors/input'
import {link} from './semantic/colors/link'
import {menu} from './semantic/colors/menu'
import {nudge} from './semantic/colors/nudge'
import {onboarding} from './semantic/colors/onboarding'
import {text} from './semantic/colors/text'
import {toast} from './semantic/colors/toast'
import {toggle} from './semantic/colors/toggle'
import {toggleButton} from './semantic/colors/toggleButton'
import {spacing} from './semantic/spacing'
import {typography} from './semantic/typography'

export const semanticTokens = {
  dark: {
    bg: bg.dark,
    text: text.dark,
    border: border.dark,
    button: button.dark,
    link: link.dark,
    toggle: toggle.dark,
    input: input.dark,
    toast: toast.dark,
    toggleButton: toggleButton.dark,
    dialog: dialog.dark,
    admonition: admonition.dark,
    menu: menu.dark,
    nudge: nudge.dark,
    onboarding: onboarding.dark,
    spacing,
    typography,
  },
  light: {
    bg: bg.light,
    text: text.light,
    border: border.light,
    button: button.light,
    link: link.light,
    toggle: toggle.light,
    input: input.light,
    toast: toast.light,
    toggleButton: toggleButton.light,
    dialog: dialog.light,
    admonition: admonition.light,
    menu: menu.light,
    nudge: nudge.light,
    onboarding: onboarding.light,
    spacing,
    typography,
  },
}

export const semanticTokensDark = semanticTokens.dark
export const semanticTokensLight = semanticTokens.light

export type SemanticTokens = typeof semanticTokens
export type SemanticThemes = keyof typeof semanticTokens

export const useSemanticTokens = () => {
  const {themeName} = useAlf()
  return useMemo(() => {
    const scheme: SemanticThemes = themeName === 'light' ? 'light' : 'dark'
    return semanticTokens[scheme]
  }, [themeName])
}
